import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router';

import InternalErrorBoundary from 'components/errors/InternalErrorBoundary';
import { A11yStateProvider } from 'context/A11yStateContext';
import { BrandContextProvider } from 'context/BrandContext';
import { FeatureFlagProvider } from 'context/FeatureFlagContext';

const PackWrapper = ({ children, rootElement, withRouter = true, store = null }) => {
  const ReduxProvider = ({ children }) => {
    if (!store) return children;
    return <Provider store={store}>{children}</Provider>;
  };

  const ReactRouter = ({ children }) => {
    if (!withRouter) return children;
    return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>{children}</Router>
    );
  };

  return (
    <InternalErrorBoundary>
      <ReduxProvider>
        <A11yStateProvider>
          <BrandContextProvider rootElement={rootElement}>
            <FeatureFlagProvider>
              <ReactRouter>{children}</ReactRouter>
            </FeatureFlagProvider>
          </BrandContextProvider>
        </A11yStateProvider>
      </ReduxProvider>
    </InternalErrorBoundary>
  );
};

PackWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  rootElement: PropTypes.object.isRequired,
  store: PropTypes.object,
  withRouter: PropTypes.bool,
};

export default PackWrapper;
